"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTruckRequestSchema = exports.CreateTruckRequestSchema = exports.TruckDtoSchema = exports.CompanyTruckSchema = exports.TruckSchema = exports.LicensePlateSchema = exports.WeightClass = exports.VehicleLength = exports.VehicleType = void 0;
const zod_1 = require("zod");
var VehicleType;
(function (VehicleType) {
    VehicleType["Sattelzug"] = "Sattelzug";
    VehicleType["Gliederzug"] = "Gliederzug";
    VehicleType["SoloLKW"] = "Solo-LKW";
})(VehicleType || (exports.VehicleType = VehicleType = {}));
var VehicleLength;
(function (VehicleLength) {
    VehicleLength["UpTo12m"] = "\u2264 12 m";
    VehicleLength["Between12And16_5m"] = "12\u201316,5 m";
    VehicleLength["Over16_5m"] = "> 16,5 m";
})(VehicleLength || (exports.VehicleLength = VehicleLength = {}));
var WeightClass;
(function (WeightClass) {
    WeightClass["UpTo7_5t"] = "\u2264 7,5 t";
    WeightClass["Between7_5And18t"] = "7,5\u201318 t";
    WeightClass["Over18t"] = "> 18 t";
})(WeightClass || (exports.WeightClass = WeightClass = {}));
exports.LicensePlateSchema = zod_1.z
    .string()
    .min(2, 'too short')
    .max(12, 'too long')
    .regex(/^[\p{L}\p{N}\-\s]+$/u, 'contains invalid characters');
exports.TruckSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid().nullable(),
    companyId: zod_1.z.string().uuid(),
    licensePlate: exports.LicensePlateSchema,
    vehicleType: zod_1.z.nativeEnum(VehicleType).nullable(),
    vehicleLength: zod_1.z.nativeEnum(VehicleLength).nullable(),
    weightClass: zod_1.z.nativeEnum(WeightClass).nullable(),
    hasHazardousGoods: zod_1.z.boolean(),
    isRefrigerated: zod_1.z.boolean(),
});
exports.CompanyTruckSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    licensePlate: exports.LicensePlateSchema,
    vehicleType: zod_1.z.nativeEnum(VehicleType).nullable(),
});
exports.TruckDtoSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    licensePlate: exports.LicensePlateSchema,
    // Nullable (not just optional): the vehicle-attribute fields are stored nullable in the
    // DB, and TruckService maps a stored null straight through — the key is always present.
    vehicleType: zod_1.z.nativeEnum(VehicleType).nullable().optional(),
    vehicleLength: zod_1.z.nativeEnum(VehicleLength).nullable().optional(),
    weightClass: zod_1.z.nativeEnum(WeightClass).nullable().optional(),
    hasHazardousGoods: zod_1.z.boolean().optional(),
    isRefrigerated: zod_1.z.boolean().optional(),
});
exports.CreateTruckRequestSchema = exports.TruckDtoSchema.omit({ id: true });
exports.UpdateTruckRequestSchema = exports.TruckDtoSchema.partial({ licensePlate: true });
//# sourceMappingURL=truck.js.map